export default __webpack_public_path__ + "static/media/eye.0ba1d175.svg";